import React from 'react';
import {connect} from 'react-redux';
import {FormattedMessage, injectIntl} from 'react-intl';

import {threadSidebarToggle} from '../../redux/actions';
import Avatar from '../Participant/Avatar';
import {Link} from '../util/Routing';
import {WhenGranted} from '../util/Permissions';
import ParticipantLink from "../Participant/ParticipantLink";

import styles from './ThreadHeader.module.css';

const InfoButton = injectIntl(({action, intl}) => (
    <button type="button"
            onClick={action}
            className={styles.infoButton}
            title={intl.formatMessage({id: 'thread.action.info'})}
    >
        <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g fill="#0180AD">
                    <path d="M12,0 C5.376,0 0,5.376 0,12 C0,18.624 5.376,24 12,24 C18.624,24 24,18.624 24,12 C24,5.376 18.624,0 12,0 L12,0 Z M13.2,18 L10.8,18 L10.8,10.8 L13.2,10.8 L13.2,18 L13.2,18 Z M13.2,8.4 L10.8,8.4 L10.8,6 L13.2,6 L13.2,8.4 L13.2,8.4 Z"/>
                </g>
            </g>
        </svg>
    </button>
));

const HistoryLink = injectIntl(({author, intl}) => {
    return (
        <Link data-target='modal'
              data-modal-size='large'
              route="imatic_communicator_thread_history"
              params={{subject: author}}
              className={styles.historyButton}
              title={intl.formatMessage({id: 'thread.action.history'})}
        >
            <svg width="28px" height="24px" viewBox="0 0 28 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g fill="#0180AD">
                        <path d="M16,0 C9.37333333,0 4,5.37333333 4,12 L0,12 L5.18666667,17.1866667 L5.28,17.3733333 L10.6666667,12 L6.66666667,12 C6.66666667,6.84 10.84,2.66666667 16,2.66666667 C21.16,2.66666667 25.3333333,6.84 25.3333333,12 C25.3333333,17.16 21.16,21.3333333 16,21.3333333 C13.4266667,21.3333333 11.0933333,20.28 9.41333333,18.5866667 L7.52,20.48 C9.69333333,22.6533333 12.68,24 16,24 C22.6266667,24 28,18.6266667 28,12 C28,5.37333333 22.6266667,0 16,0 L16,0 Z M14.6666667,6.66666667 L14.6666667,13.3333333 L20.3733333,16.72 L21.3333333,15.1066667 L16.6666667,12.3333333 L16.6666667,6.66666667 L14.6666667,6.66666667 L14.6666667,6.66666667 Z"/>
                    </g>
                </g>
            </svg>
        </Link>
    );
});

const ParticipantsLink = injectIntl(({thread, intl}) => (
    <Link data-target='modal'
          data-modal-size='large'
          route="imatic_communicator_thread_participants"
          params={{thread: thread.id}}
          className={styles.participantsButton}
          title={intl.formatMessage({id: 'thread.action.participants'})}
    >
        <svg width="24px" height="17px" viewBox="0 0 24 17" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g fill="#0180AD">
                    <path d="M17.4,8.5 C19.056,8.5 20.388,7.14 20.388,5.46428571 C20.388,3.78857143 19.056,2.42857143 17.4,2.42857143 C15.744,2.42857143 14.4,3.78857143 14.4,5.46428571 C14.4,7.14 15.744,8.5 17.4,8.5 L17.4,8.5 Z M8.4,7.28571429 C10.392,7.28571429 11.988,5.65857143 11.988,3.64285714 C11.988,1.62714286 10.392,0 8.4,0 C6.408,0 4.8,1.62714286 4.8,3.64285714 C4.8,5.65857143 6.408,7.28571429 8.4,7.28571429 L8.4,7.28571429 Z M17.4,10.9285714 C15.204,10.9285714 10.8,12.0457143 10.8,14.2678571 L10.8,17 L24,17 L24,14.2678571 C24,12.0457143 19.596,10.9285714 17.4,10.9285714 L17.4,10.9285714 Z M8.4,9.71428571 C5.604,9.71428571 0,11.135 0,13.9642857 L0,17 L8.4,17 L8.4,14.2678571 C8.4,13.2357143 8.796,11.4264286 11.244,10.0542857 C10.2,9.83571429 9.192,9.71428571 8.4,9.71428571 L8.4,9.71428571 Z"/>
                </g>
            </g>
        </svg>
    </Link>
));

const RecipientsLink = injectIntl(({thread, intl}) => (
    <Link data-target='modal'
          data-modal-size='large'
          route="imatic_communicator_thread_recipients"
          params={{thread: thread.id}}
          className={styles.recipientsButton}
          title={intl.formatMessage({id: 'thread.action.recipients'})}
    >

        <svg width="24px" height="20px" viewBox="0 0 24 20" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g transform="translate(0.000000, -2.000000)" fill="#0180AD">
                    <path d="M21.6,2 L2.4,2 C1.08,2 0.012,3.08 0.012,4.4 L0,18.8 C0,20.12 1.08,21.2 2.4,21.2 L21.6,21.2 C22.92,21.2 24,20.12 24,18.8 L24,4.4 C24,3.08 22.92,2 21.6,2 L21.6,2 Z M21.6,6.8 L12,12.8 L2.4,6.8 L2.4,4.4 L12,10.4 L21.6,4.4 L21.6,6.8 L21.6,6.8 Z" />
                </g>
            </g>
        </svg>
    </Link>
));

const ThreadHeader = ({thread, threadType, toggleSidebar}) => (
    <header className={styles.header}>
        <div className={styles.avatar}>
            <Avatar participantId={thread.author}/>
        </div>
        <div className={styles.title}>
            <h1 className="thread-header__subject">{thread.subject}</h1>
            <h2 className="thread-header__thread-type">{threadType.name}</h2>

            {thread.createdBy && (
                 <WhenGranted permission="thread.create.on_behalf_of">
                     <>
                     <FormattedMessage id="thread.createdBy"/>
                     <ParticipantLink participant={thread.createdBy}/>
                     </>
                 </WhenGranted>
            )}
        </div>
        <div className={styles.controls}>
            <InfoButton action={toggleSidebar}/>
            <WhenGranted permission="thread.show.conversation_history">
                <HistoryLink author={thread.author}/>
            </WhenGranted>
            <WhenGranted permission="thread.show.participants">
                <ParticipantsLink thread={thread}/>
            </WhenGranted>
            <WhenGranted permission="thread.show.recipients">
                <RecipientsLink thread={thread}/>
            </WhenGranted>
        </div>
    </header>
);

export default connect(
    (state) => {
        const thread = state.getIn(['threads', state.get('currentThread')]);

        return {
            thread,
            threadType: state.getIn(['threadTypes', thread.threadType]),
        };
    },
    (dispatch) => ({
        toggleSidebar() {
            return dispatch(threadSidebarToggle());
        }
    })
)(ThreadHeader);
